import { useCallback, useState } from "react"
export default function useForceUpdate() {
  const [, setVF] = useState(Object.create(null))
  const memoizedDispatch = useCallback(() => {
    setVF(Object.create(null))
  }, [setVF])
  return memoizedDispatch
}
